import { useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import ProfileSidebar from "~/components/profile-sidebar";
import Layout from "~/Layout";
import { useAccountManager } from "./useAccountManager";
import ToastMessage from "~/components/ToastMessage";

/**
 * Standalone Account Manager Profile component that doesn't require a tenant ID.
 * Used when navigating to account manager profile from contexts where tenant is not available
 * (e.g., entity onboarding before organization is selected).
 */
const AccountManagerStandalone = () => {
  const navigate = useNavigate();
  const { managerId } = useParams();
  const {
    fetchAccountManagerDetails,
    accountManagerInfo,
    handleSave,
    toastRef,
    isEditing,
    setIsEditing,
    isLoading,
    isDetailsLoading,
    fetchManagedEntities,
  } = useAccountManager();

  const TABS = [
    {
      label: "Personal Information",
      link: `/account-managers/${managerId}`,
      code: "info",
    },
    {
      label: "Managed Entities",
      link: `/account-managers/${managerId}/managed-entities`,
      code: "managed-entities",
    },
  ];

  const segments = location.pathname.split("/");
  const activeTab = segments[segments.length - 1] || "info";

  const breadcrumbs = [
    {
      label: <span className="link__style flex pointer">Account Managers</span>,
      command: () => navigate(-1), // Go back to previous page
    },
    {
      label:
        accountManagerInfo?.preferred_name ||
        [accountManagerInfo?.given_name, accountManagerInfo?.surname]
          .filter(Boolean)
          .join(" ") ||
        "Account Manager",
    },
  ];

  useEffect(() => {
    fetchAccountManagerDetails();
  }, [managerId]);

  return (
    <Layout crumbs={breadcrumbs}>
      <div className="grid">
        <div className="col-3">
          {/* Profile section */}
          <ProfileSidebar
            profileDetails={accountManagerInfo}
            title="Account Manager"
            isLoading={isDetailsLoading}
            activeTab={activeTab}
            tabs={TABS}
          />
        </div>
        <div className="col-9">
          {/*Profile detail section/ outlet */}
          <Outlet
            context={{
              accountManagerInfo,
              handleSave,
              toastRef,
              isEditing,
              setIsEditing,
              isLoading,
              fetchManagedEntities,
              managerId,
            }}
          />
        </div>
        <ToastMessage ref={toastRef} />
      </div>
    </Layout>
  );
};

export default AccountManagerStandalone;
